import { BEAT } from './branch-beats';

import type { ReactElement } from 'react';

/**
 * The two presentational atoms both branch-body files use.
 *
 * The timing vocabulary they read (`BEAT`, `enter`) lives in `branch-beats.ts`
 * so this file exports COMPONENTS only — mixing the two breaks react-refresh,
 * which matters here because the ~21s choreography is tuned by eye and a full
 * reload restarts it from zero.
 *
 * A leaf, deliberately — it imports nothing from either body file, so the two
 * halves of the card set can be split on the line ceiling without one becoming
 * the other's dependency.
 */

export function CardTitle({
  at,
  offset = BEAT.head,
  children,
}: {
  readonly at: number;
  readonly offset?: number;
  readonly children: string;
}): ReactElement {
  return (
    <div
      className="mt-3 flex-none text-[15px] font-semibold leading-tight tracking-[-0.014em] text-[#0b0f1a]"
      style={{ animation: `sxWipe .55s ease ${(at + offset).toFixed(2)}s backwards` }}
    >
      {children}
    </div>
  );
}

/** Pushes whatever follows to the card's foot. */
export function Spacer(): ReactElement {
  return <div className="flex-1" />;
}
